//Create Member by Super or Admin
import * as React from 'react';
import { useEffect, useState } from "react";
import {
  Box, Container, Grid, Typography, TextField, Button, Snackbar, Alert, CircularProgress, 
  Card, CardContent, InputAdornment, FormControl
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMutation } from "@apollo/client";
import { ADD_MEMBER_MUTATION } from "../graphql/mutations";

import { Phone, LocationOn, Home, Person,} from '@mui/icons-material';

export default function FormComponent({ onClose }) {
  const [addMember, { loading: isLoading }] = useMutation(ADD_MEMBER_MUTATION);
  // const storedUserType = localStorage.getItem("user_type");
  const [formData, setFormData] = useState({
    firstName: "",
    mobile1: "",
    mobile2: "",
    address1: "",
    address2: "",
    nagar: "",
    area: "",
    city: "",
    pincode: "",
  });

  const validateForm = () => {
    let newErrors = {};

    // Required fields validation
    if (!formData.firstName) {
      newErrors.firstName = "Name is required";
    } else if (formData.firstName.length < 3) {
      newErrors.firstName = "Name must be at least 3 characters";
    }

    if (!formData.mobile1) {
      newErrors.mobile1 = "Mobile Number is required";
    } else if (formData.mobile1.length !== 10) {
      newErrors.mobile1 = "Mobile number must be exactly 10 digits";
    }

    if (formData.mobile2 && formData.mobile2.length !== 10) {
      newErrors.mobile2 = "Alternate mobile number must be exactly 10 digits";
    }

    if (!formData.address1) {
      newErrors.address1 = "Address is required";
    }

    if (!formData.nagar) {
      newErrors.nagar = "Nagar is required";
    }

    if (!formData.area) {
      newErrors.area = "Area is required";
    }

    if (!formData.city) {
      newErrors.city = "City is required";
    }

    if (!formData.pincode) {
      newErrors.pincode = "Pincode is required";
    } else if (formData.pincode.length !== 6) {
      newErrors.pincode = "Pincode must be exactly 6 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [openSnackbar, setOpenSnackbar] = useState(false);
  // const navigate = useNavigate();
  // const { user } = useAuth();
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Run validation
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    // setIsSubmitted(true);
    const inputVariables = {
      NAME: formData.firstName, // maps to NAME
      MOBILE1: formData.mobile1, // maps to MOBILE1
      MOBILE2: formData.mobile2 || null, // maps to MOBILE2
      ADDRESS: `${formData.address1}${formData.address2 ? ", " + formData.address2 : ""}`, // maps to ADDRESS
      NAGAR: formData.nagar,
      AREA: formData.area,
      CITY: formData.city,
      PINCODE: formData.pincode,
    };

    try {
      const { data } = await addMember({ variables: inputVariables });
      setOpenSnackbar(true);
      setSnackbarMessage("Member added successfully.");
      console.log("Member added:", data.addMember);
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (error) {
      console.error("Error adding member:", error);
      console.log("Member added:", inputVariables);
      const errorMessage = error?.message || "Something went wrong while adding member.";
      setSnackbarOpen(true);
      setSnackbarMessage(errorMessage);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  }

  useEffect(() => {
    // Get mobile number & user type from localStorage
    const mobile = localStorage.getItem("mobile");
    const userType = localStorage.getItem("user_type");

    if (!mobile || !userType) {
      console.error("Mobile number or user type not found in localStorage");
      return;
    }

    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Box sx={{
      backgroundColor: "#f8f9e9",
      minHeight: "100vh",
    }}>

      <Container maxWidth="md" sx={{ py: 4 }}>
        <Card elevation={8} sx={{ borderRadius: 3, overflow: "hidden" }}>
          <Box sx={{
            backgroundColor: "#2A289C",
            color: "white",
            textAlign: "center",
            py: 3,
            background: "linear-gradient(135deg, #FAD707 0%, #FAD707 100%)"
          }}>
            <Typography variant="h5" sx={{ fontWeight: "600", color: 'black' }} gutterBottom>
              Member Registration
            </Typography>
            <Typography variant="body2" sx={{ color: 'black' }}>
              Please fill in all required details
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <form onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
                  e.preventDefault();
                }
              }}
            >
              <Grid container spacing={3}>
                {/* Name Field */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Full Name"
                      placeholder="Enter full name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      error={!!errors.firstName}
                      helperText={errors.firstName || ""}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person color="action" />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                {/* Mobile Numbers */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Mobile Number"
                      placeholder="Enter mobile number"
                      type="text"
                      name="mobile1"
                      value={formData.mobile1}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(/\D/g, "");
                        if (inputValue.length <= 10) {
                          setFormData({ ...formData, mobile1: inputValue });
                        }
                      }}
                      error={!!errors.mobile1}
                      helperText={errors.mobile1 || ""}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Phone color="action" />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Alternate Mobile"
                      placeholder="Enter alternate mobile"
                      type="text"
                      name="mobile2"
                      value={formData.mobile2}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(/\D/g, "");
                        if (inputValue.length <= 10) {
                          setFormData({ ...formData, mobile2: inputValue });
                        }
                      }}
                      error={!!errors.mobile2}
                      helperText={errors.mobile2 || ""}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Phone color="action" />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                {/* Address Fields */}
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Address Line 1 "
                      placeholder="Enter address line 1"
                      name="address1"
                      value={formData.address1}
                      onChange={handleChange}
                      error={!!errors.address1}
                      helperText={errors.address1 || ""}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Home color="action" />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Address Line 2"
                      placeholder="Enter address line 2"
                      name="address2"
                      value={formData.address2}
                      onChange={handleChange}
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Nagar "
                      placeholder="Enter nagar name"
                      name="nagar"
                      value={formData.nagar}
                      onChange={handleChange}
                      error={!!errors.nagar}
                      helperText={errors.nagar || ""}
                      required
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Area "
                      placeholder="Enter area name"
                      name="area"
                      value={formData.area}
                      onChange={handleChange}
                      error={!!errors.area}
                      helperText={errors.area || ""}
                      required
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="City "
                      placeholder="Enter city name"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      error={!!errors.city}
                      helperText={errors.city || ""}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOn color="action" />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Pincode "
                      placeholder="Enter pincode"
                      type="text"
                      name="pincode"
                      value={formData.pincode}
                      onChange={(e) => {
                        const inputValue = e.target.value.replace(/\D/g, "");
                        if (inputValue.length <= 6) {
                          setFormData({ ...formData, pincode: inputValue });
                        }
                      }}
                      error={!!errors.pincode}
                      helperText={errors.pincode || ""}
                      required
                      variant="outlined"
                    />
                  </FormControl>
                </Grid>

                {/* Action Buttons */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
                    {isLoading ? (
                      <CircularProgress color="primary" />
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        sx={{
                          backgroundColor: "#FAD707",
                          borderRadius: '8px',
                          px: 4,
                          py: 1.5,
                          color: 'black',
                          fontWeight: 600,
                          fontSize: '1rem',
                          "&:hover": {

                            transform: "translateY(-2px)",
                            boxShadow: "0 4px 8px rgba(42, 40, 156, 0.3)",
                          },
                          transition: "all 0.2s ease",
                        }}
                      >
                        Create Member
                      </Button>
                    )}
                    <Button
                      variant="outlined"
                      size="large"
                      onClick={onClose}
                      sx={{
                        borderColor: "#E52029",
                        color: "#E52029",
                        borderRadius: '8px',
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                        fontSize: '1rem',
                        "&:hover": {
                          borderColor: "#b71c1c",
                          backgroundColor: "rgba(229, 32, 41, 0.04)",
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 8px rgba(229, 32, 41, 0.2)",
                        },
                        transition: "all 0.2s ease",
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Container>

      {/* Snackbar Alert */}
      <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }} >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
          Member Created Successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>{snackbarMessage}</Alert>
      </Snackbar>
    </Box>
  );
}